module.exports = __webpack_public_path__ + "static/media/img18.1959b2c4.jpg";